import Icon from "./IconBase.js";
const NoScheduleIcon = (props) => {
  return (
    <Icon width="200" height="120" viewBox="0 0 280 180" {...props}>
      <svg
        width="251"
        height="200"
        viewBox="0 0 251 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.506836" width="250" height="200" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.5068 134H154.507C155.022 134 155.524 133.944 156.007 133.839C156.49 133.944 156.992 134 157.507 134H209.507C213.373 134 216.507 130.866 216.507 127C216.507 123.134 213.373 120 209.507 120H203.507C199.641 120 196.507 116.866 196.507 113C196.507 109.134 199.641 106 203.507 106H222.507C226.373 106 229.507 102.866 229.507 99C229.507 95.134 226.373 92 222.507 92H200.507C204.373 92 207.507 88.866 207.507 85C207.507 81.134 204.373 78 200.507 78H136.507C140.373 78 143.507 74.866 143.507 71C143.507 67.134 140.373 64 136.507 64H79.5068C75.6408 64 72.5068 67.134 72.5068 71C72.5068 74.866 75.6408 78 79.5068 78H39.5068C35.6408 78 32.5068 81.134 32.5068 85C32.5068 88.866 35.6408 92 39.5068 92H64.5068C68.3728 92 71.5068 95.134 71.5068 99C71.5068 102.866 68.3728 106 64.5068 106H24.5068C20.6408 106 17.5068 109.134 17.5068 113C17.5068 116.866 20.6408 120 24.5068 120H63.5068C59.6408 120 56.5068 123.134 56.5068 127C56.5068 130.866 59.6408 134 63.5068 134ZM226.507 134C230.373 134 233.507 130.866 233.507 127C233.507 123.134 230.373 120 226.507 120C222.641 120 219.507 123.134 219.507 127C219.507 130.866 222.641 134 226.507 134Z"
          fill="#F3F7FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.5068 140C80.3566 140 70.5068 130.374 70.5068 118.5C70.5068 106.626 80.3566 97 92.5068 97C93.0235 97 93.536 97.0174 94.0438 97.0517C93.691 95.0878 93.5068 93.0654 93.5068 91C93.5068 72.2223 108.729 57 127.507 57C142.498 57 155.223 66.702 159.745 80.1695C160.817 80.0575 161.905 80 163.007 80C179.852 80 193.507 93.4315 193.507 110C193.507 125.741 181.182 138.727 165.507 139.978V140H109.015H92.5068ZM104.503 140H97.5382H104.503Z"
          fill="white"
        />
        <path
          d="M104.503 140H97.5382M92.5068 140C80.3566 140 70.5068 130.374 70.5068 118.5C70.5068 106.626 80.3566 97 92.5068 97C93.0235 97 93.536 97.0174 94.0438 97.0517C93.691 95.0878 93.5068 93.0654 93.5068 91C93.5068 72.2223 108.729 57 127.507 57C142.498 57 155.223 66.702 159.745 80.1695C160.817 80.0575 161.905 80 163.007 80C179.852 80 193.507 93.4315 193.507 110C193.507 125.741 181.182 138.727 165.507 139.978V140H109.015H92.5068Z"
          stroke="#008DC4"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.119 64.3426C117.119 96.5657 146.14 123.118 183.507 126.703C178.824 132.461 171.592 136.368 163.354 136.981V137H96.2499C88.1082 137 74.5068 133.57 74.5068 118.548C74.5068 103.527 85.081 100.097 96.2499 100.097C96.7248 100.097 97.196 100.112 97.6627 100.141C97.3384 98.4556 97.2814 96.7184 97.1691 94.9474C96.4106 82.9842 101.63 67.907 117.137 63C117.125 63.4473 117.119 63.8944 117.119 64.3426ZM127.623 114.758C124.584 114.758 122.121 117.192 122.121 120.195C122.121 123.198 124.584 125.632 127.623 125.632C130.662 125.632 133.125 123.198 133.125 120.195C133.125 117.192 130.662 114.758 127.623 114.758Z"
          fill="#E8F0FE"
        />
        <path
          d="M128.007 126C131.044 126 133.507 123.538 133.507 120.5C133.507 117.462 131.044 115 128.007 115C124.969 115 122.507 117.462 122.507 120.5C122.507 123.538 124.969 126 128.007 126Z"
          stroke="#008DC4"
          strokeWidth="2.5"
        />
        <path
          d="M112.507 109L119.507 103.507L112.507 98.2773"
          stroke="#008DC4"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M143.507 109L136.507 103.507L143.507 98.2773"
          stroke="#008DC4"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.507 67C144.016 68.7226 149.155 73.8129 150.947 80.2932"
          stroke="#75A4FE"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M158.507 50C160.164 50 161.507 48.6569 161.507 47C161.507 45.3431 160.164 44 158.507 44C156.85 44 155.507 45.3431 155.507 47C155.507 48.6569 156.85 50 158.507 50Z"
          stroke="#75A4FE"
          strokeWidth="2"
        />
        <path
          d="M189.507 66C191.164 66 192.507 64.6569 192.507 63C192.507 61.3431 191.164 60 189.507 60C187.85 60 186.507 61.3431 186.507 63C186.507 64.6569 187.85 66 189.507 66Z"
          fill="#75A4FE"
        />
        <path
          d="M166.264 57.7578L174.622 66.116M174.749 57.7578L166.391 66.116L174.749 57.7578Z"
          stroke="#75A4FE"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.9102 75.5957L77.9102 81.5957M77.9102 75.5957L71.9102 81.5957L77.9102 75.5957Z"
          stroke="#75A4FE"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.5068 69C87.1637 69 88.5068 67.6569 88.5068 66C88.5068 64.3431 87.1637 63 85.5068 63C83.85 63 82.5068 64.3431 82.5068 66C82.5068 67.6569 83.85 69 85.5068 69Z"
          fill="#75A4FE"
        />
      </svg>
    </Icon>
  );
};
export default NoScheduleIcon;
